import { render, staticRenderFns } from "./WalletsPage.vue?vue&type=template&id=43ffaae8&scoped=true&"
import script from "./WalletsPage.vue?vue&type=script&lang=js&"
export * from "./WalletsPage.vue?vue&type=script&lang=js&"
import style0 from "./WalletsPage.vue?vue&type=style&index=0&id=43ffaae8&lang=scss&scoped=true&"
import style1 from "./WalletsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ffaae8",
  null
  
)

export default component.exports